import RequestInvitationForm from './request-invitation-form';

export default RequestInvitationForm;
